import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import gmail from '../img/gmail.svg';
import yahoo from '../img/yahoo.svg';
import outlook from '../img/outlook.svg';

let cloudsponge;

class ContactsImporter extends Component {
  static defaultProps = {
    onClose: () => {}
  }

  constructor(props) {
    super(props);
    this.state = {
      cloudspongeLoaded: false,
    }
  }

  componentDidMount() {
    cloudsponge = window.cloudsponge;

    if (!cloudsponge) return;
    this.setState({ cloudspongeLoaded: true });

    cloudsponge.init({
      skipSourceMenu: true,
      sources: ['gmail', 'yahoo', 'outlook'],
      include: ['name', 'email'],
      afterSubmitContacts: this.props.onImport,
      afterClosing: this.props.onClose
    });
  }

  importContacts = (ev) => {
    ev.stopPropagation();
    const source = ev.currentTarget.dataset.source;
    cloudsponge.launch(source);
  }

  render() {
    if (!this.state.cloudspongeLoaded) return null;
    return (
      <div className="list-group">
        <a
          href="#import-gmail"
          className="list-group-item"
          onClick={this.importContacts}
          data-source='gmail'
        >
          <img src={gmail} alt="Gmail logo" className="mr-2" />
          <FormattedMessage
            id="importContacts.findInGmail"
            defaultMessage="Find friends in your Gmail account"
          />
        </a>
        <a
          href="#import-yahoo"
          className="list-group-item"
          onClick={this.importContacts}
          data-source='yahoo'
        >
          <img src={yahoo} alt="Yahoo logo" className="mr-2" />
          <FormattedMessage
            id="importContacts.findInYahoo"
            defaultMessage="Find friends in your Yahoo account"
          />
        </a>
        <a
          href="#import-outlook"
          className="list-group-item"
          onClick={this.importContacts}
          data-source='outlook'
        >
          <img src={outlook} alt="Outlook logo" className="mr-2" />
          <FormattedMessage
            id="importContacts.findInOutlook"
            defaultMessage="Find friends in your Hotmail/Outlook account"
          />
        </a>
      </div>
    );
  }
}

export default ContactsImporter;



// WEBPACK FOOTER //
// ./src/desktop/components/contacts-importer.js